import angular from 'angular';

import { KVMControlAngular } from '@/core/views/endpoints/kvm/KVMControl';

angular.module('shbdeployer.app').component('kvmControl', KVMControlAngular).name;
